import React from "react";
import styles from "./DocumentHeader.module.css";
import favIcon from "../../../assets/images/favorite-icon.svg";
import favStrokeIcon from "../../../assets/images/favorite-strock-icon.svg";
import editIcon from "../../../assets/images/Edit.svg";
import deleteIcon from "../../../assets/images/Trash.svg";
import { useUserCapabilities } from "../../../auth.capabilities.js";

const formatDate = (value) => {
  if (!value) return "N/A";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString("en-GB");
};

const normalizeStatus = (status) => {
  const raw = String(status || "").trim().toLowerCase();
  if (raw.includes("hist")) return "history";
  if (raw === "d" || raw.includes("delete")) return "deleted";
  if (raw.includes("curr")) return "current";
  return raw ? raw : "current";
};

const normalizePreviewNew = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "new") return "new";
  if (raw === "private") return "private";
  if (raw === "preview") return "preview";
  return "";
};

const CurrentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 640 640" aria-hidden="true">
    <path
      fill="#86BD45"
      d="M424 64c13.3 0 24 10.7 24 24v40h32c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32V88c0-13.3 10.7-24 24-24s24 10.7 24 24v40h160V88c0-13.3 10.7-24 24-24M160 176c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16zm230.7 65.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5l-122.1 168c-4.1 5.7-10.5 9.3-17.5 9.8s-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36L390.7 242z"
    />
  </svg>
);

const NewIcon = () => (
  <svg width="16" height="16" viewBox="0 0 640 640" aria-hidden="true">
    <path
      fill="#0098BD"
      d="M424 64c13.3 0 24 10.7 24 24v40h32c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32V88c0-13.3 10.7-24 24-24s24 10.7 24 24v40h160V88c0-13.3 10.7-24 24-24M160 176c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16zm230.7 65.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5l-122.1 168c-4.1 5.7-10.5 9.3-17.5 9.8s-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36L390.7 242z"
    />
  </svg>
);

const PillIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentcolor">
    <circle cx="8" cy="8" r="4" />
  </svg>
);

const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
  >
    <path
      fill="none"
      stroke="#9D9D9C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 8h16M4 8v8.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.105.218h9.607c1.118 0 1.677 0 2.104-.218c.376-.192.682-.498.874-.874c.218-.428.218-.986.218-2.104V8M4 8v-.8c0-1.12 0-1.68.218-2.108c.192-.377.497-.682.874-.874C5.52 4 6.08 4 7.2 4H8m12 4v-.803c0-1.118 0-1.678-.218-2.105a2 2 0 0 0-.874-.874C18.48 4 17.92 4 16.8 4H16M8 4h8M8 4V2m8 2V2m-2 14l-2-2m0 0l-2-2m2 2l2-2m-2 2l-2 2"
    />
  </svg>
);

const HistoryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
  >
    <path
      fill="#E01129"
      d="M12 21q-1.875 0-3.512-.712t-2.85-1.925t-1.925-2.85T3 12t.713-3.512t1.924-2.85t2.85-1.925T12 3q2.05 0 3.888.875T19 6.35V5q0-.425.288-.712T20 4t.713.288T21 5v4q0 .425-.288.713T20 10h-4q-.425 0-.712-.288T15 9t.288-.712T16 8h1.75q-1.025-1.4-2.525-2.2T12 5Q9.075 5 7.038 7.038T5 12t2.038 4.963T12 19q2.375 0 4.25-1.425t2.475-3.675q.125-.4.45-.6t.725-.15q.425.05.675.362t.15.688q-.725 2.975-3.15 4.888T12 21m1-9.4l2.5 2.5q.275.275.275.7t-.275.7t-.7.275t-.7-.275l-2.8-2.8q-.15-.15-.225-.337T11 11.975V8q0-.425.288-.712T12 7t.713.288T13 8z"
    />
  </svg>
);

const StatusBadge = ({ status, usePillForNew = false }) => {
  const s = (status || "").toLowerCase();
  let badgeClass = styles.statusCurrent;
  let Icon = CurrentIcon;
  let text = "Current";

  if (s.includes("hist") || s.includes("withdrawn")) {
    badgeClass = styles.statusHistory;
    Icon = HistoryIcon;
    text = "Historic";
  } else if (s === "deleted" || s === "delete" || s === "d") {
    badgeClass = styles.statusDelete;
    Icon = DeleteIcon;
    text = "Deleted";
  } else if (s === "new") {
    badgeClass = styles.statusNew;
    Icon = usePillForNew ? PillIcon : NewIcon;
    text = "New";
  } else if (s === "preview") {
    badgeClass = styles.statusPreview;
    Icon = PillIcon;
    text = "Preview";
  } else if (s === "private") {
    badgeClass = styles.statusPrivate;
    Icon = PillIcon;
    text = "Private";
  }

  return (
    <span className={`${styles.statusBadge} ${badgeClass}`}>
      <Icon />
      {text}
    </span>
  );
};

export default function DocumentHeader({
  documentData,
  isFav,
  favResolved = true,
  onToggleFavourite,
  isEditMode = false,
  canSave = true,
  canReturnToStandard = false,
  canCopyIssue = false,
  onEnterEdit,
  onSave,
  onCopyIssue,
  onCancel,
  onReturnToStandard,
  onDelete,
  saveLoading = false,
  copyIssueLoading = false,
  deleteLoading = false,
  hideEditActions = false,
  canDelete = true,
  tabsDisabled = false,
  activeTab,
  onTabChange,
  favBusy = false,
  onAddToDownloadQueue,
  addToDownloadQueueDisabled = false,
  tabs = [
    { id: "overview", label: "Overview" },
    { id: "refdoc", label: "Reference Documents" },
    { id: "history", label: "Other Editions" },
    { id: "variations", label: "Variations" },
  ],
}) {
  const user = useUserCapabilities() || {};
  const hasAdminRights = !!user.hasAdminRights;

  if (!documentData) return null;

  const ref = documentData.reference ?? documentData.referenceNumber ?? "N/A";
  const title = documentData.name ?? documentData.title ?? "Untitled";
  const pubDate = formatDate(documentData.publicationDate ?? documentData.issueDate);
  const compDate = formatDate(documentData.complianceDate);

  const statusKey = normalizeStatus(documentData.status ?? documentData.statusId);
  const pillKey = normalizePreviewNew(documentData.newOrPrivate);
  const showCancel = typeof onCancel === "function";
  const showReturnToStandard = typeof onReturnToStandard === "function";

  return (
    <section className={styles.documentHeaderPanel}>
      <div className={styles.documentActions}>
        {isEditMode && !hideEditActions ? (
          <>
            {canSave ? (
              <button
                type="button"
                className={styles.saveBtn}
                onClick={onSave}
                disabled={saveLoading || copyIssueLoading}
              >
                {saveLoading ? "Saving..." : "Save"}
              </button>
            ) : null}
            {showReturnToStandard ? (
              <button
                type="button"
                className={`${styles.saveBtn} ${styles.returnBtn}`}
                onClick={onReturnToStandard}
                disabled={saveLoading || copyIssueLoading}
              >
                Return To Standard
              </button>
            ) : null}
            <button
              type="button"
              className={styles.copyBtn}
              onClick={onCopyIssue}
              disabled={!canCopyIssue || saveLoading || copyIssueLoading || deleteLoading}
            >
              {copyIssueLoading ? "Copying..." : "Copy Issue"}
            </button>
            {showCancel ? (
              <button
                type="button"
                className={styles.cancelBtn}
                onClick={onCancel}
                disabled={saveLoading || copyIssueLoading || deleteLoading}
              >
                Cancel
              </button>
            ) : null}
          </>
        ) : !isEditMode ? (
          <>
            <button
              type="button"
              className={styles.actionBtn}
              title={
                !favResolved
                  ? "Checking favourite status..."
                  : isFav
                    ? "Remove from favourites"
                    : "Add to favourites"
              }
              onClick={onToggleFavourite}
              disabled={favBusy || !favResolved}
            >
              {favResolved ? (
                <img
                  src={isFav ? favIcon : favStrokeIcon}
                  alt="Favourite toggle"
                  width={18}
                  height={18}
                />
              ) : (
                <span className={styles.iconPlaceholder} aria-hidden="true" />
              )}
            </button>

            {hasAdminRights && (
              <button
                type="button"
                className={styles.actionBtn}
                title="Edit document"
                onClick={onEnterEdit}
                disabled={deleteLoading}
              >
                <img src={editIcon} alt="Edit" width={18} height={18} />
              </button>
            )}

            {hasAdminRights && canDelete && (
              <button
                type="button"
                className={styles.actionBtn}
                title="Delete document"
                onClick={onDelete}
                disabled={deleteLoading}
              >
                <img src={deleteIcon} alt="Delete" width={18} height={18} />
              </button>
            )}
          </>
        ) : null}
      </div>

      <div className={styles.documentContent}>
        <div className={styles.refRow}>
          <span className={styles.refValue}>{ref}</span>
        </div>

        <h1 className={styles.documentTitle}>{title}</h1>

        <div className={styles.metaRow}>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Publication Date</span>
            <span className={styles.metricValue}>{pubDate}</span>
          </div>

          <div className={styles.metric}>
            <span className={styles.metricLabel}>Compliance Date</span>
            <span className={styles.metricValue}>{compDate}</span>
          </div>

          <div className={styles.badges}>
            <StatusBadge status={statusKey} />
            {pillKey ? <StatusBadge status={pillKey} usePillForNew /> : <span>-</span>}
          </div>
        </div>

        <div className={styles.tabBar}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`${styles.tab} ${activeTab === tab.id ? styles.tabActive : ""}`}
              onClick={() => onTabChange(tab.id)}
              disabled={tabsDisabled}
            >
              {tab.label}
            </button>
          ))}
          {typeof onAddToDownloadQueue === "function" ? (
            <button
              type="button"
              className={styles.downloadQueueButton}
              onClick={onAddToDownloadQueue}
              disabled={tabsDisabled || addToDownloadQueueDisabled}
            >
              Add to Download Queue
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
}

